export const PRICE_PRECISION = 3;
export const ADDITIONAL_CHARGES_PRECISION = 2;
export const PERCENTAGE_PRECISION = 1;
export const DB_PRICE_PRECISION = 4;
